import { Injectable } from "@angular/core";
import { MarcheNegocie } from "../../models/MarcheNegocie";
import { Procedure } from "../../models/Procedure";
import { TypeOuiNon } from "../../models/TypeOuiNon";

@Injectable({
    providedIn: 'root'
})
export class ProcedureService {

    constructor() {
    }

    public getProcedure(controls): Procedure {

        const procedure = new Procedure();
        procedure.dialogueCompetitif = controls.get('_SepSep_AttributionFromMAPA_SepSep_Procedure_SepAtt_dialogueCompetitif')
        procedure.appelRestreint = controls.get('_SepSep_AttributionFromMAPA_SepSep_Procedure_SepAtt_appelRestreint')
        procedure.concoursOuvert = controls.get('_SepSep_AttributionFromMAPA_SepSep_Procedure_SepAtt_concoursOuvert')
        procedure.concoursRestreint = controls.get('_SepSep_AttributionFromMAPA_SepSep_Procedure_SepAtt_concoursRestreint')
        procedure.procedureAdaptee = controls.get('_SepSep_AttributionFromMAPA_SepSep_Procedure_SepAtt_procedureAdaptee')
        procedure.appelOuvert = controls.get('_SepSep_AttributionFromMAPA_SepSep_Procedure_SepAtt_appelOuvert')
        procedure.autres = controls.get('_SepSep_AttributionFromMAPA_SepSep_Procedure_SepAtt_autres')

        procedure.marcheNegocie = new MarcheNegocie();

        procedure.marcheNegocie.candidatsDejaSelectionnes = new TypeOuiNon();
        procedure.marcheNegocie.candidatsDejaSelectionnes.non = controls.get('_SepSep_AttributionFromMAPA_SepSep_Procedure_SepSep_MarcheNegocie_SepSep_TypeOuiNon_SepAtt_non')
        procedure.marcheNegocie.candidatsDejaSelectionnes.oui = controls.get('_SepSep_AttributionFromMAPA_SepSep_Procedure_SepSep_MarcheNegocie_SepSep_TypeOuiNon_SepAtt_oui')

        return procedure;
    }
}
